import classNames from 'classnames';
import React from 'react';
import { Image, Subtitle2, Body1 } from '@fluentui/react-components';

import { useNoAssetCardStyles } from '../styles/no-asset-card-styles';
import NoAssetsImage from '../../media/no-assets-image.png';
import NoAssetsFilteredImage from '../../media/no-assets-filtered-image.png';

export enum NO_ASSETS_STATE {
  NO_ASSETS = 'NO_ASSETS',
  NO_ASSETS_FILTERED = 'NO_ASSETS_FILTERED',
}

const config = {
  [NO_ASSETS_STATE.NO_ASSETS]: {
    image: (styles, i18n) => <Image alt={i18n.getString(_TL_('No assets found'))} fit="contain" src={NoAssetsImage} className={classNames('no-assets-image', styles.image)} />,
    title: _TL_('Your campaign can\'t run without assets'),
    text: _TL_('Your performance max campaign needs assets to run. Our AI tools will help you to create your assets including text and images.'),
  },
  [NO_ASSETS_STATE.NO_ASSETS_FILTERED]: {
    image: (styles, i18n) => <Image alt={i18n.getString(_TL_('No assets found for current filter options'))} fit="contain" src={NoAssetsFilteredImage} className={classNames('no-filtered-assets-image', styles.image)} />,
    title: _TL_('No assets available'),
    text: _TL_('Select a different filter and try again.'),
  },
};

export function NoAssetsCard({ i18n, state }: { i18n: any, state: NO_ASSETS_STATE.NO_ASSETS | NO_ASSETS_STATE.NO_ASSETS_FILTERED }) {
  const styles = useNoAssetCardStyles();
  return (
    <div className={classNames('no-assets-container', styles.container)}>
      <div className={classNames(styles.imageContainer, state === NO_ASSETS_STATE.NO_ASSETS && styles.gradient)}>
        {config[state].image(styles, i18n)}
      </div>
      <Subtitle2 className={classNames('title', styles.title)}>{i18n.getString(config[state].title)}</Subtitle2>
      <Body1 className="text">{i18n.getString(config[state].text)}</Body1>
    </div >
  );
}
